import { render, staticRenderFns } from "./moeda.vue?vue&type=template&id=0b645098"
import script from "./moeda.ts?vue&type=script&lang=js&external"
export * from "./moeda.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b645098')) {
      api.createRecord('0b645098', component.options)
    } else {
      api.reload('0b645098', component.options)
    }
    module.hot.accept("./moeda.vue?vue&type=template&id=0b645098", function () {
      api.rerender('0b645098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/moeda.vue"
export default component.exports